// extracted by mini-css-extract-plugin
module.exports = {"label":"BottomLabel_label__1U42k","error":"BottomLabel_error__E4ecf"};